import { render } from "./WalletInfoModal.vue?vue&type=template&id=36f6f3d0&scoped=true"
import script from "./WalletInfoModal.vue?vue&type=script&lang=js"
export * from "./WalletInfoModal.vue?vue&type=script&lang=js"

import "./WalletInfoModal.vue?vue&type=style&index=0&id=36f6f3d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f6f3d0"]])

export default __exports__